var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "修改历史记录",
        visible: _vm.visible,
        width: "80%",
        "before-close": _vm.handleClose
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.historyData,
            "header-cell-style": _vm.headerStyle,
            "row-class-name": _vm.tableRowClassName
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "序号", align: "center", width: "80" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operationType",
              label: "操作类型",
              align: "center",
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operator",
              label: "操作人",
              align: "center",
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "operateTime",
              label: "操作时间",
              align: "center",
              width: "180"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "changeInfo", label: "变更信息", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.changeInfo || "-"))])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageParams.pageNum,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageParams.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }